import React from "react"

import { Loader } from "@googlemaps/js-api-loader"

import { Container, Card, Row, Col } from "react-bootstrap"

function OfficeMap() {
    var styles = [
        {
            stylers: [
                {
                    saturation: -80,
                },
            ],
        },
    ]

    const loader = new Loader({
        apiKey: process.env.GOOGLE_MAPS,
        version: "weekly",
        libraries: ["places"],
        nonce: "T4n23MXvZO",
    })

    const mapOptions = {
        center: {
            lat: parseFloat(50.59368),
            lng: parseFloat(-1.20199),
        },
        zoom: 15,
        styles: styles,
    }

    loader
        .load()
        .then((google) => {
            const map = new google.maps.Map(
                document.getElementById("map"),
                mapOptions,
            )
            new google.maps.Marker({
                position: {
                    lat: parseFloat(50.59368),
                    lng: parseFloat(-1.20199),
                },
                map: map,
            })
        })
        .catch((e) => {})

    return (
        <Container fluid="md" className="mt-4 px-0">
            <Row className="mx-0">
                <Col xs={12} as={Card} className="p-0">
                    <div id="map" className="office-map"></div>
                </Col>
            </Row>
        </Container>
    )
}

export default OfficeMap
